<template>
  <div class="v-token">
    <fieldset class="v-token__fieldset">
      <legend />
      <div class="v-token__inputs">
        <VNewTokenInput
          v-for="(item, index) in numberOfDigits"
          :key="index"
          :inputId="`token_input_${cardId}_${index}`"
          :index="index"
          @input="setFieldValue($event, item, index)"
          @focusPreviousField="setFocusOnPrevField($event, index)"
          @focus="setFocusAll"
          @blur="verifyStatus"
          :tokenCompleted="tokenCompleted"
          :tokenIncompleted="tokenIncompleted"
          :tokenFocused="!tokenCompleted && tokenFocused"
          :tokenBlured="!tokenCompleted && !tokenFocused && !tokenIncompleted"
        />
      </div>
      <div class="error-container" v-if="tokenIncompleted && !tokenFocused">
        <AlertCircleStrokeSvg />
        <span class="error-msg"> Insira o token do seu atendimento.</span>
      </div>
    </fieldset>
  </div>
</template>

<script>
import VNewTokenInput from '@/components/commons/VNewToken/VNewTokenInput.vue';

export default {
  name: 'VNewToken',
  components: {
    VNewTokenInput,
  },
  props: {
    cardId: {
      type: String,
      default: '',
    },
    verifyTokensBeforeSubmit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      numberOfDigits: 6,
      tokenFieldsListModel: [],
      tokenModel: '',
      isTokenInvalidLocal: false,
      tokenFocused: false,
      tokenCompleted: false,
      tokenIncompleted: false,
    };
  },
  watch: {
    verifyTokensBeforeSubmit: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.verifyStatus();
      }
    },
  },
  methods: {
    verifyStatus() {
      const currentToken = this.getTokenInputedAsIs();
      const tokenIsCompleted = currentToken.length === this.numberOfDigits;
      if (!tokenIsCompleted) {
        this.tokenBlur = false;
        this.tokenFocused = false;
        this.tokenIncompleted = true;
        this.tokenCompleted = false;
      } else {
        this.tokenBlur = false;
        this.tokenFocused = false;
        this.tokenIncompleted = false;
        this.tokenCompleted = true;
      }
    },
    getTokenInputedAsIs() {
      const cardIndex = this.cardId[this.cardId.length - 1];
      let token = '';
      for (let j = 0; j < this.numberOfDigits; j++) {
        token += document.getElementById(`token_input_card_${cardIndex}_${j}`).value || '';
      }
      return token;
    },
    setFocusAll() {
      this.tokenCompleted = false;
      this.tokenBlur = false;
      this.tokenFocused = true;
    },
    setFocusOnPrevField(event, itemIndex) {
      const toFocusFieldIndex = itemIndex - 1 >= 0 ? itemIndex - 1 : 0;

      const toFocusField = document.getElementById(
        `token_input_${this.cardId}_${toFocusFieldIndex}`,
      );
      toFocusField.focus();
    },

    setFieldValue(eventValue, item, index) {
      const nextTokenField = document.getElementById(`token_input_${this.cardId}_${index + 1}`);
      this.tokenFieldsListModel[index] = eventValue;
      this.isTokenInvalidLocal = false;

      if (eventValue && nextTokenField) {
        nextTokenField.focus();
      }

      if (this.hasTokenFormatMatched(this.tokenFieldsListModel)) {
        this.checkTokenModelFill();
      }
    },
    hasTokenFormatMatched(tokenValue) {
      let hasTokenFormatMatched = false;

      if (tokenValue) {
        if (Array.isArray(tokenValue) || typeof tokenValue === 'string') {
          hasTokenFormatMatched = tokenValue.length === 6;
        }
      }

      return hasTokenFormatMatched;
    },

    checkTokenModelFill() {
      const isAllFieldsFilled = this.tokenFieldsListModel.every((value, index) => {
        return !!value;
      });

      if (isAllFieldsFilled) {
        this.tokenModel = '';

        for (const item of this.tokenFieldsListModel) {
          this.tokenModel += item;
        }

        this.$emit('tokenHasCompleted', this.tokenModel);
      } else {
        this.tokenCompleted = false;
      }
    },

    getInputValueByIndex(index) {
      const itemInputValue = this.retrievedValue ? this.retrievedValue[index] : '';
      return itemInputValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.error-msg {
  font-size: 12px;
  line-height: 133%;
  text-align: left;
  color: #960012;
}

.error-container {
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 4px;
}
.v-token {
  display: flex;
  flex-direction: row;
  width: 100%;

  &__fieldset {
    border: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__inputs {
    border: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    gap: 9.03px;
  }

  &__message {
    color: var(--color-error);
    display: flex;
    flex-direction: row;
    font-size: var(--font-size-1);
    width: 100%;

    svg {
      height: auto;
      margin-right: 5px;
      width: 12px;

      path {
        fill: var(--color-error);
        height: auto;
      }
    }
  }
}
</style>
